/**
 * api接口调用
 */

import axios from 'axios'
// import { Message } from 'element-ui'
// process.env.BASE_API

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL, // api的base_url
    headers: {'Content-Type': 'application/json;charset=utf-8'},
    transformRequest: [function (data) { // 允许在请求数据发送到服务器之前对其进行更改
      data = JSON.stringify(data)
      return data
    }],
    timeout: 0 // 请求超时时间,指定请求超时的毫秒数(0 表示无超时时间)
  })
  // request拦截器
  service.interceptors.request.use(
    config => { // 请求的时候可以做一些拦截操作
  
        return config;

      // if (config.data !== undefined) {
      //   if (!config.data.isJSON) { // 如果传递的数据以formData形式则做如下处理，否则默认是JSON格式数据
      //     config.headers = {
      //       'Content-Type': 'application/x-www-form-urlencoded'
      //     }
      //     config.transformRequest = [function (data) {
      //       let ret = ''
      //       for (let it in data) {
      //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      //       }
      //       return ret
      //     }]
      //   }
      // }
  
    },
    error => {
      // 请求错误的时候
      // console.log(error) // for debug
      Promise.reject(error)
    })
  
  // respone拦截器
  service.interceptors.response.use(
    response => { // 在这里可以做一些拦截操作，比如说登陆过期/在别的地方登陆等等
      if (response.data.code === '401') {
       
      } else {
        return response.data
      }
    },
    error => {
      return Promise.reject(error)
    }
  )
  
  export default service